/**
 * 퀘스트 진행 판정. Phaser 없음.
 */

import { getQuest, type QuestDef } from '../data/quests';
import type { Inventory } from './Inventory';

export interface QuestSave {
  status: 'active' | 'done';
  kills: number;
}

export type QuestPhase = 'locked' | 'offer' | 'active' | 'ready' | 'done';

export function fillQuestText(template: string, progress: number, need: number): string {
  return template.replaceAll('{progress}', String(progress)).replaceAll('{need}', String(need));
}

export function questProgress(def: QuestDef, save: QuestSave | undefined, inventory: Inventory): number {
  if (def.kind === 'hunt') return save?.kills ?? 0;
  if (def.kind === 'collect' && def.itemId) return inventory.countOf(def.itemId);
  return 0;
}

export function questPhase(
  questId: string,
  quests: Record<string, QuestSave>,
  inventory: Inventory,
): QuestPhase {
  const def = getQuest(questId);
  if (!def) return 'locked';
  const save = quests[questId];
  if (save?.status === 'done') return 'done';
  for (const req of def.requires) {
    if (quests[req]?.status !== 'done') return 'locked';
  }
  if (save?.status === 'active') {
    return questProgress(def, save, inventory) >= def.count ? 'ready' : 'active';
  }
  return 'offer';
}

export function pickNpcQuest(
  questIds: readonly string[] | undefined,
  quests: Record<string, QuestSave>,
  inventory: Inventory,
): { id: string; phase: QuestPhase } | null {
  if (!questIds) return null;
  for (const id of questIds) {
    const phase = questPhase(id, quests, inventory);
    if (phase === 'offer' || phase === 'active' || phase === 'ready') return { id, phase };
  }
  for (const id of questIds) {
    if (questPhase(id, quests, inventory) === 'done') return { id, phase: 'done' };
  }
  return null;
}
